<template lang="pug">
.card.height-100
  .card-body
    .columns
      .column.col-12
        text-output(
          :label="'cgcm.razao_social' | tModel",
          :text="socio.cgcm.razao_social"
        )
      .column.col-6
        text-output(
          :label="'cgcm.cpf_cnpj' | tModel",
          :text="socio.cgcm.cpf_cnpj | cpfCnpj"
        )
      .column.col-6
        text-output(:label="'socio.vinculo' | tModel", :text="socio.vinculo")
      .column.col-6
        text-output(
          :label="'socio.percentual' | tModel",
          :text="socio.percentual | currency"
        )
      .column.col-6
        text-output(
          :label="'socio.principal' | tModel",
          :text="socio.principal ? 'Sim' : 'Não'"
        )
</template>

<script>
export default {
  props: { socio: { type: Object, required: true } },
};
</script>
